import { Component, OnInit, OnDestroy, Input, ElementRef, ModuleWithProviders } from '@angular/core';
import { WalkthroughService } from 'app/shared/services/walkthrough/walkthrough.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'tog-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnDestroy {
  tooltipBody: any;
  tooltipTarget: any;
  tooltipShown: boolean = false;
  @Input() tooltipText: string = '';
  @Input() offsetLeft: number = 0;
  @Input() offsetTop: number = 0;
  @Input() walkthroughMode: boolean = false;
  @Input() walkthroughName: string = '';
  @Input() id: number = 0;
  walkthroughSubscription: Subscription;

  // Controls hover style
  tooltipStyle: { width: string, height: string, left: string, right: string, top: string, bottom: string } =
              { width: '340px', height: 'auto', left: '', right: '', top: '', bottom: '' };

  constructor(private _el: ElementRef, public walkthroughService: WalkthroughService) { }

  ngOnInit() {
    let self = this;
    this.tooltipBody = this._el.nativeElement;
    this.tooltipTarget = this._el.nativeElement.parentNode;
    document.body.appendChild(self.tooltipBody);

    if (!this.walkthroughMode) {
      this.tooltipTarget.onmouseenter = function () {
        self.show();
      };

      this.tooltipTarget.onmouseleave = function () {
        self.hide();
      };
    } else {
      this.walkthroughSubscription = this.walkthroughService.walkthroughs[this.walkthroughName].nextStep.subscribe((newStep: number) => {
        if (newStep == -1) {
          this.hide();
          this.walkthroughSubscription.unsubscribe();
        } else if (newStep == this.id) {
          this.show();
        } else {
          this.hide();
        }
      });
    }
  }

  calculatePagePosition() {
    let elementBounds = this.tooltipTarget.getBoundingClientRect();
    if (this.tooltipBody.classList.contains('feature')) {
      elementBounds = this.tooltipTarget.children[0].getBoundingClientRect();
    }
    if (this.walkthroughMode) {
      elementBounds = this.adjustScrollToShowTooltip(elementBounds);
      this.adjustTooltipDirection(elementBounds);
    }
    let tool = this.tooltipBody.children[0].getBoundingClientRect();
    this.tooltipStyle.left = elementBounds.left + elementBounds.width + 10 + this.offsetLeft + 'px';
    this.tooltipStyle.top = elementBounds.top + (elementBounds.height / 2) - (tool.height / 2) + this.offsetTop + 'px';
    this.tooltipBody.getElementsByClassName('oi-caret-left')[0].style.top = (tool.height / 2) - 4 + 'px';

    if (this.tooltipBody.classList.contains('top-left-arrow')) {
      this.tooltipStyle.top = elementBounds.top + (elementBounds.height / 2) - (tool.height / 5) + this.offsetTop + 'px';
      this.tooltipBody.getElementsByClassName('oi-caret-left')[0].style.top = (tool.height / 5) - 4 + 'px';

    }

    if (this.tooltipBody.classList.contains('bottom-tooltip')) {
      this.tooltipStyle.top = elementBounds.top + elementBounds.height + this.offsetTop + 'px';
      this.tooltipStyle.left = elementBounds.left - 20 + this.offsetLeft + 'px';
      this.tooltipBody.getElementsByClassName('oi-caret-top')[0].style.left = elementBounds.width + 'px';

      if (this.tooltipBody.classList.contains('center-arrow')) this.forceHorizontalCenterArrow('oi-caret-top');
    }

    if (this.tooltipBody.classList.contains('left-tooltip')) {
      this.tooltipStyle.left = elementBounds.left - (parseInt(this.tooltipStyle.width, 10) / 2) - 10 + this.offsetLeft + 'px';
      this.tooltipStyle.top = elementBounds.top + (elementBounds.height / 2.5) - (tool.height / 2) + this.offsetTop + 'px';
      this.tooltipBody.getElementsByClassName('oi-caret-right')[0].style.top = (tool.height / 2) - 4 + 'px';

      if (this.tooltipBody.classList.contains('center-arrow')) this.forceVerticalCenterArrow('oi-caret-left');
    }

    if (this.tooltipBody.classList.contains('top-tooltip')) {
      this.tooltipStyle.left = elementBounds.left - (tool.width / 2) + this.offsetLeft + 'px';
      this.tooltipStyle.top = elementBounds.top - tool.height - 10 + this.offsetTop + 'px';
      this.tooltipBody.getElementsByClassName('oi-caret-bottom')[0].style.top = tool.height - 4 + 'px';
      this.tooltipBody.getElementsByClassName('oi-caret-bottom')[0].style.left = (parseInt(this.tooltipStyle.width, 10) / 4) + 'px';

      if (this.tooltipBody.classList.contains('center-arrow')) this.forceHorizontalCenterArrow('oi-caret-bottom');

    }

    if (this.tooltipBody.classList.contains('bottom-right-arrow')) {
      let offset = parseInt(this.tooltipStyle.width, 10) / 12;
      this.tooltipBody.getElementsByClassName('oi-caret-bottom')[0].style.left = (parseInt(this.tooltipStyle.width, 10) / 4) + offset + 'px';
      this.tooltipStyle.left = parseInt(this.tooltipStyle.left, 10) - offset + 5 + this.offsetLeft + 'px';
    }
  }

  adjustScrollToShowTooltip(bounds: any) {
    let el = document.getElementsByClassName('tog-root-content')[0];
    if (bounds.top > (window.innerHeight - 150)) {
      el.scrollTop = bounds.top - window.innerHeight + 200;
      let newPosition = this.tooltipTarget.getBoundingClientRect();
    } else if (bounds.top < 0) {
      el.scrollTop = bounds.top - 100;
    }
    return this.tooltipTarget.getBoundingClientRect();
  }

  // Checks if we should change the positioning of the tooltip
  // based on how close to the bottom/top of the page it is
  adjustTooltipDirection(bounds: any) {
    if (window.innerHeight - bounds.top < 199 && this.tooltipBody.classList.contains('bottom-tooltip')) {
      this.tooltipBody.classList.remove('bottom-tooltip');
      this.tooltipBody.classList.add('top-tooltip');
    }
  }

  forceHorizontalCenterArrow(className: string) {
    this.tooltipBody.getElementsByClassName(className)[0].style.left = (this.tooltipBody.children[0].clientWidth / 2) + 'px';
  }

  forceVerticalCenterArrow(className: string) {
    this.tooltipBody.getElementsByClassName(className)[0].style.left = (this.tooltipBody.children[0].clientHeight / 2) + 'px';
  }

  show() {
    this.calculatePagePosition();
    this.tooltipShown = true;
  }

  hide() {
    this.tooltipShown = false;
  }

  next() {
    if (this.walkthroughMode) {
      this.walkthroughService.nextStep(this.walkthroughName);
    }
  }

  ngOnDestroy() {
    if (document.body.contains(this.tooltipBody)) {
      document.body.removeChild(this.tooltipBody);
    }
    if (this.walkthroughSubscription) {
      this.walkthroughSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/tooltip/tooltip.component.ts